var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "title" }, [_vm._v("CREATE APPLICATION")]),
    _vm._v(" "),
    _c("div", { staticClass: "application-type" }, [
      _c("div", { staticClass: "title-section" }, [_vm._v("Application Type")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "types" },
        _vm._l(_vm.modes, function(mode) {
          return _c(
            "div",
            {
              key: mode.id,
              staticClass: "type",
              class: { active: mode.id === _vm.modeSelected },
              on: {
                click: function($event) {
                  _vm.modeSelected = mode.id
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/" + mode.id + ".png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "mode-option" }, [
                _vm._v(_vm._s(mode.text))
              ])
            ]
          )
        })
      )
    ]),
    _vm._v(" "),
    _vm.modeSelected
      ? _c("div", { staticClass: "form-create-app" }, [
          _c("div", { staticClass: "form-section d-flex" }, [
            _c(
              "div",
              {
                staticClass: "preview-icon",
                class: { "error-icon": _vm.$v.application.icon_url.$error }
              },
              [
                _vm.application.icon_url
                  ? _c("img", { attrs: { src: _vm.application.icon_url } })
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  ref: "iconUpload",
                  staticClass: "upload-photo",
                  attrs: { type: "file" },
                  on: {
                    change: function($event) {
                      _vm.handleIconUpload($event)
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "title-config" }, [
                _vm._v("Application Icon")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc-config" }, [
                _vm._v(
                  "\n          Icon must be minimum size 1024 x 1024px and .png format.\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "upload-btn",
                  on: {
                    click: function($event) {
                      _vm.$refs.iconUpload.click()
                    }
                  }
                },
                [_vm._v("\n          Upload\n        ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1",
                  class: { "error-input": _vm.$v.application.app_name.$error }
                },
                [
                  _c("label", [_vm._v(" Application Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required": false,
                      placeholder: "Enter application name"
                    },
                    model: {
                      value: _vm.application.app_name,
                      callback: function($$v) {
                        _vm.$set(_vm.application, "app_name", $$v)
                      },
                      expression: "application.app_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.modeSelected === "hyperlink"
                ? _c(
                    "b-form-group",
                    {
                      staticClass: "mb-1",
                      class: {
                        "error-input": _vm.$v.application.app_url.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" URL ")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "error-required": false,
                          placeholder: "Enter url"
                        },
                        model: {
                          value: _vm.application.app_url,
                          callback: function($$v) {
                            _vm.$set(_vm.application, "app_url", $$v)
                          },
                          expression: "application.app_url"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1",
                  class: { "error-input": _vm.$v.application.desc_name.$error }
                },
                [
                  _c("label", [_vm._v(" Description ")]),
                  _vm._v(" "),
                  _c("j-textarea", {
                    attrs: {
                      "error-required": false,
                      placeholder: "Enter application description"
                    },
                    model: {
                      value: _vm.application.desc_name,
                      callback: function($$v) {
                        _vm.$set(_vm.application, "desc_name", $$v)
                      },
                      expression: "application.desc_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", [_vm._v(" Group Application ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options: _vm.groupOptions,
                      "error-required": false,
                      placeholder: "Select Group",
                      "value-format": "object"
                    },
                    model: {
                      value: _vm.selectedGroup,
                      callback: function($$v) {
                        _vm.selectedGroup = $$v
                      },
                      expression: "selectedGroup"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.modeSelected === "hyperlink"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mt-3"
                    },
                    [
                      _c("label", [
                        _vm._v(" Open Hyperlink in App Browser (Mobile) ")
                      ]),
                      _vm._v(" "),
                      _c("j-switch", {
                        model: {
                          value: _vm.application.open_hyperlink_in_app_browser,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.application,
                              "open_hyperlink_in_app_browser",
                              $$v
                            )
                          },
                          expression:
                            "application.open_hyperlink_in_app_browser"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.modeSelected === "hyperlink"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mt-3"
                    },
                    [
                      _c("label", [_vm._v(" Use Token ")]),
                      _vm._v(" "),
                      _c("j-switch", {
                        model: {
                          value: _vm.application.use_token,
                          callback: function($$v) {
                            _vm.$set(_vm.application, "use_token", $$v)
                          },
                          expression: "application.use_token"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.application.is_offline_mode
                ? _c("div", { staticClass: "local-storage mt-3" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/logo/offline-mode.png"),
                        height: "16"
                      }
                    }),
                    _vm._v("\n        Local Storage Support\n      ")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "form-section d-flex justify-content-between align-items-center"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("j-switch", {
                model: {
                  value: _vm.application.search_menu,
                  callback: function($$v) {
                    _vm.$set(_vm.application, "search_menu", $$v)
                  },
                  expression: "application.search_menu"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-section" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              _vm._l(_vm.listDisplayOptions, function(option) {
                return _c(
                  "div",
                  {
                    key: option.id,
                    staticClass: "btn-option",
                    class: {
                      active: _vm.displayModeSelected.includes(option.id)
                    },
                    on: {
                      click: function($event) {
                        _vm.handleDisplayMode(option.id)
                      }
                    }
                  },
                  [
                    !_vm.displayModeSelected.includes(option.id)
                      ? _c("div", { staticClass: "circle-checkbox" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayModeSelected.includes(option.id)
                      ? _c("img", {
                          staticClass: "checked",
                          attrs: {
                            src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "icon-btn",
                      attrs: {
                        src: require("@/assets/form-ui/" +
                          option.id +
                          (_vm.displayModeSelected.includes(option.id)
                            ? "-active"
                            : "") +
                          ".svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(option.text))])
                  ]
                )
              })
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
      _c(
        "button",
        { staticClass: "button-close mr-2", on: { click: _vm.closeModal } },
        [_vm._v("\n      Close\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button-create-app",
          attrs: { disabled: !_vm.modeSelected },
          on: { click: _vm.createApp }
        },
        [_vm._v("\n      Create App\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-2" }, [
      _c("p", { staticClass: "title-config" }, [_vm._v("General Information")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config" }, [
        _vm._v("\n          Information to describe the application\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "title-config" }, [_vm._v("Search Menu")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config" }, [
        _vm._v(
          "\n          A search bar or search box in order to look up menu or page\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-2" }, [
      _c("p", { staticClass: "title-config" }, [_vm._v("Display Mode")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config" }, [
        _vm._v(
          "\n          Select the device that will be used to display this application\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5af361e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af361e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/tabs/partials/jModalCreateApp.vue
// module id = null
// module chunks = 